/* eslint-disable */
<template>
  <div class="settings h-100">
    <AdminNavigation ref="navigation" indexProps="9"/>
    <div class="top-panel">
      <Header/>
      <div class="header-title-section">
        <div class="header-title"><h1>Manage Specialty</h1></div>
        <div class="header-sub-title"></div>
      </div>
    </div>
    <div class="panel h-100">
      <AdminSettingsMenu indexProps="1"/>
      <div class="content h-100">
        <div class="tool-bar row">
          <div class="col d-flex justify-content-end">
            <v-btn class="add-icon" dark @click="addNew">Add New</v-btn>
          </div>
        </div>
        <div class="content-scroll-x">
          <el-table :data="records" tooltip-effect="dark" :header-row-style="{background: '#fde9eb', height: '70px'}"
                    :header-cell-style="{fontWeight: 100}">
            <el-table-column
                width="120"
                prop="QualificationID"
                label="ID"
                show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
                show-overflow-tooltip
                label="Qualification Name"
                prop="QualificationName"
            >
            </el-table-column>
          </el-table>
          <div v-if="totalCount > listParam.pageSize" class="pagination">
            Page
            <div class="pagination-group">
              <div class="border-icon pagination-current dropdown">
                <div class="pagination-current-text">{{ listParam.pageNum }}</div>
                <div class="pagination-current-icon" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"></div>
                <div class="dropdown-menu shadow" aria-labelledby="pagination-current-icon">
                  <div class="dropdown-item" v-for="item in (1, Math.ceil(totalCount/listParam.pageSize))" :key="item" :class="listParam.pageNum === item ? 'selected' : ''" :value="item" @click="selectPage(item)">
                    {{ item }}
                  </div>
                </div>
              </div>
            </div>
            <div class="pagination-total">of &nbsp; {{ Math.ceil(totalCount/listParam.pageSize) }}</div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
        top="5vh"
        :close-on-click-modal="false"
        title="Create"
        :visible.sync="dialogVisible"
        width="80%">
      <div class="box-row">
        <div class="box-col box-col-left left-label">Qualification Name</div>
        <div class="box-col-right">
          <el-input v-model="curItem.QualificationName" maxlength="100"/>
          <div v-if="hasError && qualificationNameError" class="text-danger">
            {{ qualificationNameError }}
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
    <el-button @click="cancelModal">Cancel</el-button>
    <el-button type="primary" @click="onSave">Save</el-button>
  </span>
    </el-dialog>
  </div>
</template>

<script>
import utilities from '@/assets/js/utilities'
import AdminNavigation from '@/components/AdminNavigation'
import AdminSettingsMenu from '@/components/AdminSettingsMenu'
import Header from '@/components/Header'
import {debounce} from 'lodash';
import "tinymce/tinymce";
import "tinymce/themes/silver";
import "tinymce/icons/default";
import "tinymce/skins/ui/oxide/skin.css";
import 'tinymce/plugins/link';
import 'tinymce/plugins/image';
import 'tinymce/plugins/code';
import 'tinymce/plugins/table';
import 'tinymce/plugins/spellchecker'
import Editor from "@tinymce/tinymce-vue";

export default {
  name: 'AdminManageEmail',
  components: {
    AdminNavigation,
    AdminSettingsMenu,
    Header,
    Editor
  },
  data() {
    return {
      option: {
        plugins: 'link image code table spellchecker',
        browser_spellcheck: true,
        contextmenu: false,
        height: 400,
        branding: false,
        menu: false
      },
      curValue: null,
      content: '',
      hasError: false,
      records: [],
      dialogVisible: false,
      successMessage: '',
      mode: 'create',
      totalCount: 0,
      curItem: {
        TemplateName: '',
        Body: '',
        SendTo: '',
        Status: 1,
      },
      listParam: {
        pageNum: 1,
        pageSize: 10,
        EmailTemplateID: null,
        SendTo: null,
        TemplateName: '',
        Status: null
      },
      emailToType: [{
        name: 'RH2',
        value: 0
      }, {
        name: 'Client Contact',
        value: 1
      }, {
        name: 'Specialist',
        value: 2
      }, {
        name: 'Examinee',
        value: 3
      }, {
        name: 'Custom',
        value: 4
      }],
      fieldList: [],
      editorOptions: {
        lineHeight: 1
      }
    }
  },
  computed: {
    qualificationNameError() {
      const s = String(this.curItem.QualificationName || '').trim()
      if (!s) {
        return 'Qualification Name is required.'
      }
      if (s.length > 100) {
        return 'Qualification Name must not exceed 100 characters.'
      }
      if (!/(?=.*[A-Za-z])/.test(s)) {
        return 'Qualification Name must include at least one English letter.'
      }
      if (!/^[A-Za-z\s\-()&]+$/.test(s)) {
        return 'Qualification Name may only contain English letters, spaces, hyphen (-), parentheses ( ), and ampersand (&).'
      }
      return ''
    },
    validateTemplateName() {
      return !this.qualificationNameError
    },
    validateEmail() {
      return (this.curItem.SendTo !== null && this.curItem.SendTo !== '')
    },
    validateEmailBody() {
      return this.curItem.Body.trim() !== ''
    },
  },
  methods: {
    search: debounce(function () {
      this.selectPage(1)
    }, 800),
    handleDelete(item) {
      this.$confirm({
        content: 'Are you sure you want to delete this template?',
        onConfirm: async () => {
          this.curItem = item
          this.curItem.Deleted = 1
          await this.$store.dispatch("loading/setLoadComponent", true)
          await utilities.deleteSMSTemplate(this.curItem.SmsTemplateID)
          await this.$store.dispatch("loading/setLoadComponent", false)
          this.selectPage(1)
        }
      })
    },
    async onSave() {
      if(!this.validateTemplateName) {
        this.hasError = true
        return
      } else {
        this.hasError = false
      }
      this.curItem.QualificationName = String(this.curItem.QualificationName || '').trim()

      await this.$store.dispatch("loading/setLoadComponent", true)
      await utilities.postSpecialty(this.curItem)
      await this.$store.dispatch("loading/setLoadComponent", false)
      this.cancelModal()
      this.selectPage(1)
    },
    cancelModal() {
      this.dialogVisible = false
      this.curItem = {
        TemplateName: '',
        Body: '',
        SendTo: '',
        Status: 1,
      }
    },
    handleClickModal(item) {
      let obj = JSON.parse(JSON.stringify(item))
      for (let key in obj) {
        if( typeof(obj[key]) === 'string' && key !== 'Body')
          obj[key] = decodeURIComponent(obj[key])
      }
      // obj.Body = obj.Body.replaceAll("%27", "'")
      this.curItem = obj
      this.hasError = false
      this.dialogVisible = true
    },
    selectPage(index) {
      this.listParam.pageNum = index
      this.loadData()
    },
    onSelectOption(text) {
      this.curItem.Body = this.curItem.Body + ' ' + text + ' '
    },
    async loadData() {
      let obj = {...this.listParam}
      for (let key in obj) {
        if (obj[key] === null || obj[key] === '') {
          delete obj[key];
        }
      }
      await this.$store.dispatch("loading/setLoadComponent", true)
      try {
        const {data, total} = await utilities.getSettingSpecialties(obj)
        console.log(data)
        this.records = data ? data : []
        this.totalCount = total
        await this.$store.dispatch("loading/setLoadComponent", false)
      } catch (e) {
        this.records =  []
        this.totalCount = 0
        await this.$store.dispatch("loading/setLoadComponent", false)
      }

    },

    addNew() {
      this.curItem = {
        QualificationName: ''
      }
      this.hasError = false
      this.dialogVisible = true
    },
  },
  async beforeMount() {
    await this.loadData()
  },
  mounted() {
  },
}
</script>
